module.exports = __webpack_public_path__ + "img/tramites-mobile.a73fd132.jpg";